'use strict';

var aviarySizes = require('../../../../../../../../../_virtual/aviarySizes.cjs');

const AVIARY_SIZES = {
    xxsmall: "xxsmall",
    xsmall: "xsmall",
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};

aviarySizes.__exports.AVIARY_SIZES = AVIARY_SIZES;

module.exports = aviarySizes.__exports;
//# sourceMappingURL=aviarySizes.cjs.map
